module.exports = __webpack_public_path__ + "static/media/hopin.dd166490.png";